import api from '@/helpers/api'
import axios from '@/helpers/axios'
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        allData: null,
        m3Company: null,
        indicators: null,
        maxBudget: 0,
        companies: [],
        licenses: null
    },
    getters: {
        allData: state => state.allData,
        m3Company: state => state.m3Company,
        indicators: state => state.indicators,
        maxBudget: state => state.maxBudget,
        companies: state => state.companies,
        licenses: state => state.licenses

    },
    mutations: {
        SET_ALLDATA(state, allData) {
            state.allData = allData
        },
        SET_M3COMPANY(state, m3Company) {
            state.m3Company = m3Company
        },
        SET_INDICATORS(state, indicators) {
            state.indicators = indicators
        },
        SET_MAXBUDGET(state, maxBudget) {
            state.maxBudget = maxBudget
            if(state.allData) {
                state.allData.maxBudget = maxBudget
            }
        },
        SET_COMPANIES(state, companies) {
            state.companies = companies
        },
        SET_LICENSES(state, licenses) {
            state.licenses = licenses
        }
    },
    actions: {

        setMaxBudget({commit}, maxBudget){
            commit('SET_MAXBUDGET', maxBudget);
        },

        initializeCompanies({commit}) {
            axios.get(api.API_ENDPOINTS.m3company)
                .then(response => {
                    commit('SET_COMPANIES', response.data);
                })
        },

        initializeM3Company({commit}) {
            axios.get(api.API_ENDPOINTS.m3company)
                .then(response => {
                    if(response && response.data && response.data.length){
                        commit('SET_COMPANIES', response.data);
                        commit('SET_M3COMPANY', response.data[0])
                        localStorage.removeItem('currentM3Company');
                        localStorage.setItem('currentM3Company', JSON.stringify(response.data[0]));
                    }
                })
        },

        setM3Company({commit}, m3Company){
            commit('SET_M3COMPANY', m3Company);
        },

        setCompanies({commit}, companies){
            commit('SET_COMPANIES', companies);
        },

        setLicenses({commit}, licenses) {
            commit('SET_LICENSES', licenses)
        },

        resetM3Sketch({commit}) {
            commit('SET_ALLDATA', null);
            commit('SET_M3COMPANY', null);
            commit('SET_INDICATORS', null);
            commit('SET_MAXBUDGET', 0);
            commit('SET_COMPANIES', []);
            commit('SET_LICENSES', null);
        },

        syncGantt(){
            if(this.getters['m3Sketch/allData'] && this.getters['m3Sketch/allData'].m3_project && this.getters['m3Sketch/allData'].m3_project.activities && this.getters['m3Sketch/allData'].m3_project.activities.activities){
                axios.get(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id + '/grant-application')
                    .then( (response) => {
                        let m3GrantApplication = response.data;
                        let newM3GrantApplication = [];

                        if(m3GrantApplication && m3GrantApplication.activitati_previzionate){
                            this.getters['m3Sketch/allData'].m3_project.activities.activities.forEach(mainActivity => {
                                let newActivity = true;
                                let min = 25;
                                let max = 0;

                                mainActivity.childrens.forEach(child => {
                                    if(min > child.date[0])
                                        min = child.date[0]

                                    if(max < child.date[1])
                                        max = child.date[1]
                                })

                                m3GrantApplication.activitati_previzionate.forEach(activity => {
                                    if(mainActivity.id === activity.id || (activity.title === ('A' + mainActivity.number + ' ' + mainActivity.title))){
                                        newActivity = false;
                                        newM3GrantApplication.push({
                                            id: mainActivity.id,
                                            title: 'A' + mainActivity.number + ' ' + mainActivity.title,
                                            date: [min, max],
                                            partner: activity.partner,
                                            details: activity.details,
                                            results: activity.results,
                                            address: activity.address
                                        });
                                    }
                                })

                                if(newActivity){
                                    newM3GrantApplication.push({
                                        id: mainActivity.id,
                                        title: 'A' + mainActivity.number + ' ' + mainActivity.title,
                                        date: [min, max],
                                        partner: this.getters['m3Sketch/m3Company'].name,
                                        details: '',
                                        results: '',
                                        address: []
                                    });
                                }
                                mainActivity.childrens.forEach(child => {
                                    newActivity = true;

                                    m3GrantApplication.activitati_previzionate.forEach(activity => {
                                        if (child.id === activity.id || (activity.title === (mainActivity.number + '.' + child.number + ' ' + child.title))) {
                                            newActivity = false;
                                            newM3GrantApplication.push({
                                                id: child.id,
                                                title: mainActivity.number + '.' + child.number + ' ' + child.title,
                                                date: child.date,
                                                partner: activity.partner,
                                                details: activity.details,
                                                results: activity.results,
                                                address: activity.address
                                            });
                                        }
                                    })

                                    if (newActivity) {
                                        newM3GrantApplication.push({
                                            id: child.id,
                                            title: mainActivity.number + '.' + child.number + ' ' + child.title,
                                            date: child.date,
                                            partner: this.getters['m3Sketch/m3Company'].name,
                                            details: '',
                                            results: '',
                                            address: []
                                        });
                                    }
                                })
                            })
                            axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id + '/grant-application',  {activitati_previzionate: newM3GrantApplication})
                                .then( () => {
                                    this.dispatch('finantare/removeFromProgress', 'Activitati previzionate')
                                })
                        }

                    })
            }
        },

        initializeAllData({ commit }) {
            if( this.getters['m3Sketch/m3Company'] ){
                axios.get(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id)
                    .then( response => {
                        commit('SET_ALLDATA', response.data);
                        commit('SET_MAXBUDGET', response.data.max_budget);

                        if(!response.data.turnover || !response.data.max_budget || !response.data.turnover_2020){
                            axios.get(api.API_ENDPOINTS.m3 + this.getters['m3Sketch/m3Company'].business_id + '/v1')
                                .then(response2 => {

                                    let ajutorM1 = this.getters['stateAids/getStateAids'].m1
                                    let ajutorM2 = this.getters['stateAids/getStateAids'].m2
                                    let ajutorHoreca = this.getters['stateAids/getStateAids'].horeca

                                    let help_moneyM1 = null
                                    if(ajutorM1) {
                                        if(ajutorM1['Status contract'] !== 'Respins'){
                                            help_moneyM1 = '9679'
                                        }
                                    }

                                    let help_moneyM2 = null
                                    if(ajutorM2) {
                                        if(ajutorM2['Status contract'] !== 'Contract respins' || ajutorM2['Status contract'] !== 'Respins in lista de asteptare' || ajutorM2['Status contract'] !== 'Respins In lista de asteptare'){
                                            help_moneyM2 = ajutorM2['Suma solicitata']
                                        }
                                    }

                                    let help_moneyHoreca = null
                                    if(ajutorHoreca) {
                                        if(ajutorHoreca.Status === 'Aprobată'){
                                            help_moneyHoreca = ajutorHoreca['Suma solicitata']
                                        }
                                    }

                                    let allData = this.getters['m3Sketch/allData'];

                                    allData.turnover = response2.data ? response2.data.CA_2019 : 0
                                    commit('SET_ALLDATA', allData);

                                    if(!response.data.turnover || !response.data.turnover_2020){
                                        this.form = {
                                            turnover: response2.data ? response2.data.CA_2019 : 0,
                                            turnover_2020: response2.data ? response2.data.CA_2020 : 0,
                                            _method: 'PUT'
                                        }
                                        axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id, this.form)
                                    }
                                    allData.turnover_2020 = response2.data ? response2.data.CA_2020 : 0
                                    commit('SET_ALLDATA', allData);

                                    if(!response.data.max_budget){
                                        this.formSend = {
                                            m1: help_moneyM1 ? (Number(help_moneyM1) / 4.8395).toFixed(0) : 0,
                                            m2: help_moneyM2 ? (Number(help_moneyM2) / 4.8395) .toFixed(0): 0,
                                            horeca: help_moneyHoreca ? (Number(help_moneyHoreca) / 4.9260).toFixed(0) : 0,
                                            ca: (Number(response2.data.CA_2019) / 4.946).toFixed(0)
                                        }
                                        axios.post(api.API_ENDPOINTS.m3MaxBudget + '/' + this.getters['m3Sketch/m3Company'].id, this.formSend)
                                            .then(response => {
                                                allData = this.getters['m3Sketch/allData'];
                                                allData.maxBudget = Number(response.data.budget).toFixed(0)
                                                commit('SET_ALLDATA', allData);
                                            })
                                    }
                                })
                        }

                        if(!response.data.capital_2020 || !response.data.active){
                            axios.get(api.API_ENDPOINTS.m3 + this.getters['m3Sketch/m3Company'].business_id + '/v3')
                                .then( response3 => {
                                    let allData = this.getters['m3Sketch/allData'];
                                    let bilant2020 = _.filter(response3.data.bilant_scurt, v => v.an === 2020);
                                    if(bilant2020.length > 0){
                                        bilant2020 = bilant2020[0];

                                        if(!response.data.capital_2020){
                                            allData.capital_2020 = bilant2020 ? bilant2020.capital_total : 0
                                            commit('SET_ALLDATA', allData);

                                            let formCapital2020 = {
                                                capital_2020: bilant2020 ? bilant2020.capital_total : 0,
                                                _method: 'PUT'
                                            }
                                            axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id, formCapital2020)
                                        }

                                        if(!response.data.active){
                                            allData.active = bilant2020 ? (Number(bilant2020.active_circulante ? bilant2020.active_circulante : 0) + Number(bilant2020.active_imobilizate ? bilant2020.active_imobilizate : 0) + Number(bilant2020.cheltuieli_in_avant ? bilant2020.cheltuieli_in_avant : 0)) : 0
                                            commit('SET_ALLDATA', allData);

                                            let formActive = {
                                                active: bilant2020 ? (Number(bilant2020.active_circulante) + Number(bilant2020.active_imobilizate) + Number(bilant2020.cheltuieli_in_avant)) : 0,
                                                _method: 'PUT'
                                            }
                                            axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id, formActive)
                                        }
                                    }
                                })
                        }
                    })
                    .finally(() => this.dispatch('pageLoading/setLoading', false))
                    .catch( xhr => {
                        console.log(xhr);
                    })
            }
        },

        initializeIndicators({commit}) {
            if(this.getters['m3Sketch/m3Company']){
                axios.get(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id + '/project/indicators')
                    .then( response => {
                        commit('SET_INDICATORS', response.data);
                        this.totalScore = {
                            scadareCa: response.data.scadere_ca,
                            investitiiMediu: response.data.investitii_mediu,
                            caenNegativ: response.data.caen_negativ,
                            produsInovativ: response.data.produs_inovativ,
                            crestereProductivitate: response.data.cresterea_productivitatii
                        }
                        localStorage.setItem('totalScore', JSON.stringify(this.totalScore))
                        localStorage.setItem('procentActiveNecorporale', JSON.stringify(response.data.active_necorporale))
                    })
                    .catch( xhr => {
                        console.log(xhr);
                    })
            }
        },
        setAllData({commit}, allData){
            commit('SET_ALLDATA', allData);
        },

        saveAllDataPart({commit}, form){
            return new Promise((resolve, reject) => {
                let allData = this.getters['m3Sketch/allData'];
                Object.entries(form).forEach(([key, value]) => {
                    allData[key] = value;
                })
                axios.put(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id, form)
                    .then((response) => {
                        commit('SET_ALLDATA', allData);
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })

        },

        saveAllDataProjectPart({commit}, form){
            return new Promise((resolve, reject) => {
                let allData = this.getters['m3Sketch/allData'];
                Object.entries(form).forEach(([key, value]) => {
                    allData.m3_project[key] = value;
                })

                axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id + '/project', form)
                    .then((response) => {
                        commit('SET_ALLDATA', allData);
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })

        },

        saveAllDataProjectPartWithFiles({commit}, form){
            return new Promise((resolve, reject) => {
                let allData = this.getters['m3Sketch/allData'];
                Object.entries(form).forEach(([key, value]) => {
                    allData.m3_project[key] = value;
                })

                axios.post(api.API_ENDPOINTS.m3company + this.getters['m3Sketch/m3Company'].id + '/project', form, {
                    header: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((response) => {
                        commit('SET_ALLDATA', allData);
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })

        }
    },
}
